import logging from '@wr/logging';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {Redirect} from 'react-router';
import {getPoliPaymentStatusClient} from '../../../actions/poli/browser';
import propLoaders from '../../../prop-loaders';
import {redirectTo} from '../../../utils/helpers';
import {useTranslations} from '../../../utils/selectors';
import Spinner from '../../atoms/Spinner';
import {ERROR_STATUS, PAYMENT_STATUS} from './consts';
import {getErrorStatusCode} from './helpers';
import config from '../../../config';

const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);

const PoliStatusWaiting = ({
    initStatusData,
    match,
    errorCode: initialErrorCode
}) => {
    const {sessionId: paymentSessionId, language} = match.params;
    const {
        poli: {
            spinner: {
                title: defaultTitle,
                subTitle
            },
            notFound, unexpectedError
        }
    } = useTranslations();

    const [errorCode, setErrorCode] = useState(initialErrorCode);
    const [statusData, setStatusData] = useState(initStatusData || {});

    let title = defaultTitle;
    let titleClass = 'poli-container__title';

    const hasStatus = status => !errorCode && statusData.paymentStatus === status;


    useEffect(() => {
        const getPaymentStatus = async () => {
            try {
                const newStatusData = await getPoliPaymentStatusClient({paymentSessionId, language});
                setStatusData(newStatusData);
            } catch (err) {
                logger.error(err);
                setErrorCode(getErrorStatusCode(err));
            }
        };

        if (hasStatus(PAYMENT_STATUS.PENDING)) {
            setTimeout(getPaymentStatus, 2000);
        }
        if (hasStatus(PAYMENT_STATUS.DONE)) {
            redirectTo(statusData.redirectUrl);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusData, errorCode, language, paymentSessionId]);

    if (typeof window === 'undefined' && hasStatus(PAYMENT_STATUS.DONE)) {
        return <Redirect to={statusData.redirectUrl} />;
    }

    if (errorCode) {
        if (errorCode === ERROR_STATUS.NOT_FOUND_PAYMENT_ID) {
            title = notFound;
            titleClass += ' poli-container__title--not-found';
        } else {
            title = unexpectedError;
            titleClass += ' poli-container__title--something_wrong';
        }
    }

    return (
        <section className="poli-container">
            <h1 className={titleClass}>
                {title}
            </h1>
            {!errorCode && (
                <>
                    <div className="poli-container__spinner">
                        <Spinner />
                    </div>
                    <h2 className="poli-container__sub-title">
                        {subTitle}
                    </h2>
                </>
            )}
        </section>
    );
};


PoliStatusWaiting.getServerSideProps = async context => {
    try {
        const {requestId, sessionId, params} = context;
        const paymentSessionId = params.sessionId;
        const initStatusData = await propLoaders.getPoliPaymentStatus(
            {requestId, sessionId, query: {paymentSessionId}}
        );
        return {initStatusData};
    } catch (error) {
        return {
            errorCode: getErrorStatusCode(error),
            initStatusData: {}
        };
    }
};

PoliStatusWaiting.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            language: PropTypes.string.isRequired,
            sessionId: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    initStatusData: PropTypes.shape({
        redirectUrl: PropTypes.string,
        paymentStatus: PropTypes.oneOf([
            PAYMENT_STATUS.DONE,
            PAYMENT_STATUS.PENDING
        ])
    }),
    errorCode: PropTypes.number
};

PoliStatusWaiting.defaultProps = {
    initStatusData: {},
    errorCode: null
};

export default PoliStatusWaiting;
